export const MEMBERSHIP_LEVELS = ['Ingen', 'Brons', 'Silver', 'Guld'];
